module.exports = __webpack_public_path__ + "new-tab.svg?6a0736d4bc93e23ffe93968c15a836c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-tab.svg
// module id = 93
// module chunks = 2